import React from 'react';
import { makeStyles } from '@material-ui/core';

import { escapeText } from '@root/utils/text.utils';

const useStyles = makeStyles(() => ({
  generationAtom: {
    padding: '12px',
  },

  SERPUrl: {
    color: 'rgb(32, 33, 36)',
    fontFamily: 'Arial',
    fontSize: '0.925rem',
  },
  SERPTitle: {
    color: 'rgb(26, 13, 171)',
    fontWeight: 400,
    fontlineHeight: '26px',
    fontSize: '20px',
    fontFamily: 'arial, sans-serif',
    marginBottom: '10px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  SERPDescription: {
    fontWeight: 400,
    color: 'rgb(77, 81, 86)',
    fontFamily: 'arial, sans-serif',
    fontSize: '1rem',
    paddingBottom: '1.25rem',
  },
  paraStyle: {
    color: 'black',
    backgroundColor: 'rgb(240,240,240)',
    margin: '-2px',
    padding: '0 4px 0 4px',
    fontFamily: 'monospace',
    fontWeight: '400',
    fontSize: '13px',
  },
}));

const encodeStr = (rawStr) => rawStr.replace(/[\u00A0-\u9999<>&]/gim, (i) => `&#${i.charCodeAt(0)};`);

const SeoMetatagPreview = ({
  content,
  fileData = {},
  onTextSelect = () => null,
}) => {
  const classes = useStyles();

  let title = '';
  let description = '';
  if (content.length >= 2) {
    title = content[0] || '';
    description = content[1] || '';
  }

  const [selectedField, setSelectedField] = React.useState(null);

  const onFieldSelect = (field) => () => setSelectedField(field);

  const onContentSelect = () => {
    const text = escapeText(window.getSelection().toString());

    if (!text || !escapeText(content[selectedField]).includes(text)) {
      onTextSelect(null);
      return;
    }

    onTextSelect({
      text,
      field: selectedField,
    });
  };

  return (
    <div className={classes.generationAtom} onMouseUp={onContentSelect}>
      <div className={classes.SERPUrl}>
        {fileData.url}
      </div>

      <div onMouseMove={onFieldSelect(0)} className={classes.SERPTitle}>
        <span>{title}</span>
      </div>

      <div style={{ marginTop: 10 }} onMouseMove={onFieldSelect(1)}>
        <div className={classes.SERPDescription}>
          {description.split('\n').map((para) => (
            <div
              key={para}
              className={classes.descriptionStyle}
            >
              <span>{para}</span>
            </div>
          ))}
        </div>
      </div>
      <div
        className={classes.paraStyle}
      >
        <p>
          {' '}
          {`<title>${encodeStr(title)}</title>`}
        </p>
        <p>
          {`<meta name="description" content="${encodeStr(
            description,
          )}">`}
        </p>
      </div>
    </div>

  );
};

export default SeoMetatagPreview;
